import { HudIcon } from '../../Icons/HudIcons';
import { themeColor } from '../../theme/colors';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 2px;
  opacity: 0.4;
  width: fit-content;
  height: 28px;
  &:hover {
    opacity: 1;
  }
  transform: translateX(-4px);
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  /* flex-shrink: 0; */
  border-radius: 100px;
  background: ${themeColor('purpleHome')};
  &.warning {
    background: var(--red-200);
  }
`;

export const PlusDot = styled(HudIcon).attrs({
  icon: 'other.plusDot',
  size: '8px',
})<{
  icon?: never;
}>``;
